// Talkjs conversation statuses
export const CONVERSATION_ENDED = 'CONVERSATION_ENDED';
export const NOT_SET = 'NOT_SET';
export const NOT_FOUND = 'Not found'; // When API returns 404
